import { useQuery } from "@apollo/client";
import { ROUND } from "../rounds.queries";
import {
  RoundQuery,
  RoundQueryVariables,
} from "../../../__generated__/RoundQuery";

export const useRound = (id: number) => {
  return useQuery<RoundQuery, RoundQueryVariables>(ROUND, {
    variables: { id },
  });
};
